import { BlogImageRoot } from './BlogImage.styles'
import { addParametersToContentfulUrl } from 'utils/addParametersToContentfulUrl'

export type BlogImageType = {
  fields: {
    file: {
      url: string
      details: {
        image: {
          width: number
          height: number
        }
      }
    }
    title: string
  }
}

type BlogImageProps = {
  content: BlogImageType
}

export const BlogImage = ({ content, ...rest }: BlogImageProps) => {
  return (
    <BlogImageRoot {...rest}>
      <img src={`https:${addParametersToContentfulUrl(content.fields.file.url, [{ name: 'fm', value: 'webp' }])}`} alt={content.fields.title} />
    </BlogImageRoot>
  )
}
